import { render, staticRenderFns } from "./VehicleContractEntityDetails.vue?vue&type=template&id=b4ebc65e&"
import script from "./VehicleContractEntityDetails.vue?vue&type=script&lang=js&"
export * from "./VehicleContractEntityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4ebc65e')) {
      api.createRecord('b4ebc65e', component.options)
    } else {
      api.reload('b4ebc65e', component.options)
    }
    module.hot.accept("./VehicleContractEntityDetails.vue?vue&type=template&id=b4ebc65e&", function () {
      api.rerender('b4ebc65e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VehicleContractEntityDetails.vue"
export default component.exports